export default "__VITE_ASSET__BajpkRxK__"